export * from './SelectedLifestylesSidebarFooter.types';
export { default as SelectedLifestylesSidebarFooter } from './SelectedLifestylesSidebarFooter';
